import React, { useState, useEffect } from 'react';
import { Modal, Button, Input, Spin, Alert, Flex } from 'antd';
import instance from './services/base-url';
import { Typography } from 'antd';

const AddressSelector = ({ onAddressSelect }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [savedLocations, setSavedLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [locName, setLocName ] = useState('');

  const { Link } = Typography;


  // Open modal and fetch saved locations
  const openModal = () => {
    setIsModalOpen(true);
    setLoading(true);
    setError(null);

    instance.get('/api/Locations') // Replace with your actual endpoint
      .then(res => {
        setSavedLocations(res.data);
        setFilteredLocations(res.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load saved locations. Please try again.');
        setLoading(false);
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSearchTerm('');
    setFilteredLocations([]);
  };

  // Filter locations based on search term
  useEffect(() => {
    const filtered = savedLocations.filter(loc =>
      loc.address.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredLocations(filtered);
  }, [searchTerm, savedLocations]);

  // Handle selection from modal
  const handleSelectLocation = (loc) => {
    console.log("location ", loc);
    const addressObj = {
      lat: loc.latitude,
      lng: loc.longitude,
      name: loc.address,
      city: loc.city,
      region: loc.region,
      country: loc.country
    };
    onAddressSelect(addressObj); // Pass selected address to parent
    setLocName(loc.name);
    closeModal();
  };

  return (
    <div style={{ display: 'flex', flexDirection:'column', gap:'20px', alignItems: 'flex-start' }}>
      {/* Button to open modal */}
     
       <Link onClick={openModal}>
           Click this link to search location locally or type in the box below
        </Link>
        
      {locName && (
       
            <div style={{ mt: 0, display:'Flex', width:'100%', whiteSpace:'nowrap', fontStyle: 'italic', color: '#555' }}>
                 {locName} 
             </div>
       
        )}

      {/* Modal for saved locations */}
      <Modal
        title="Select Saved Location"
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
      >
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spin tip="Loading saved locations..." />
          </div>
        ) : error ? (
          <Alert message={error} type="error" showIcon />
        ) : (
          <>
            <Input
              placeholder="Search saved addresses"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ marginBottom: '10px' }}
            />
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {filteredLocations.map(loc => (
                <li
                  key={loc.id}
                  onClick={() => handleSelectLocation(loc)}
                  style={{
                    cursor: 'pointer',
                    padding: '10px',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <strong>{loc.address}</strong><br />
                  {loc.city}, {loc.region}, {loc.country}
                </li>
              ))}
            </ul>
          </>
        )}
      </Modal>
    </div>
  );
};

export default AddressSelector;
